package one.devsbox.www.ui.locations.detail

import androidx.compose.material3.MaterialTheme
import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember
import androidx.compose.ui.graphics.Color
import one.devsbox.www.provider.LocalMeProvider
import one.devsbox.www.provider.LocalPreferencesProvider
import one.devsbox.www.provider.PreferencesProvider
import one.devsbox.www.provider.MeProvider
import one.devsbox.www.tools.ArgsId
import tk.mallumo.compose.navigation.LocalNavigation
import tk.mallumo.compose.navigation.LocalNavigationArgs
import tk.mallumo.compose.navigation.Navigation
import tk.mallumo.compose.navigation.args
import tk.mallumo.compose.navigation.viewmodel.viewModel

class LocationDCtx private constructor(
    val vm: LocationDVM,
    val nav: Navigation,
    val args: ArgsId,
    val me: MeProvider,
    val prefs: PreferencesProvider,
    val colorPrimaryContainer: Color,
    val colorSecondaryContainer: Color,
    val colorErrorContainer: Color
) {
    companion object {
        @Composable
        fun get(): LocationDCtx {
            val nav = LocalNavigation.current
            val args = LocalNavigationArgs.current.args<ArgsId>()
            val vm = nav.viewModel(LocationDVM::class)
            val me = LocalMeProvider.current
            val prefs = LocalPreferencesProvider.current
            val colorPrimary = MaterialTheme.colorScheme.primaryContainer
            val colorSecondary = MaterialTheme.colorScheme.secondaryContainer
            val colorError = MaterialTheme.colorScheme.errorContainer
            return remember {
                LocationDCtx(
                    vm, nav, args, me, prefs,
                    colorPrimary, colorSecondary, colorError
                ).apply {
                    vm.setup(this)
                }
            }
        }
    }

    val action get() = vm.action
}
